"use strict";
// NOTE: These types are the only parts of "@azure/functions" referenced/exported from the "applicationinsights" package
// This is done so that the "applicationinsights" package does not need a direct dependency on "@azure/functions"
// These types should be compatible with both functions model v3 and model v4
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Functions.js.map